import { format } from 'date-fns';

export function formatFullDate(
	publicationDate: string,
	formatType = 'MM/dd/yyyy',
) {
	const parsedDate = new Date(publicationDate);
	return format(parsedDate, formatType);
}
